import './App.css';
import Layout from './components/layout';
import RenderRouter from './routers';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <Layout>
      <RenderRouter />
      <ToastContainer />
    </Layout>
  );
}

export default App;
